export const rolesApi = (client) => ({
    list: () => client.get('/api/v1/roles').then((r) => r.data),
    get: (id) => client.get(`/api/v1/roles/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/roles', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/roles/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/roles/${id}`).then((r) => r.data),
    duplicate: (id) => client.post(`/api/v1/roles/${id}/duplicate`).then((r) => r.data),
    listUsers: (id) => client
        .get(`/api/v1/roles/${id}/users`)
        .then((r) => r.data),
});
export const permissionsApi = (client) => ({
    list: () => client.get('/api/v1/permissions').then((r) => r.data),
    listModules: () => client.get('/api/v1/permissions/modules').then((r) => r.data),
});
//# sourceMappingURL=roles.js.map